<template lang="html">
  <div class="course">
    <div class="content">
      <div v-for="a in teachingList" :key="a.courseid" class="teachingList" @click="goCourse(a.courseid)">
        <div class="courseBanner" :style="{backgroundImage: 'url('+ a.pic +')'}">
          <img src="../../../assets/image/icon/discount.png" alt="" class="discountIcon" v-show="a.discount < 10">
          <span class="discountNum" v-show="a.discount < 10">{{a.discount}}折</span>
        </div>
        
        <p class="courseTitle">{{a.title}}</p>
        <div class="coursePrice">
          <p class="currentPrice"><span>{{a.price}}</span>巢币</p>
          <p class="originalCost" v-show="a.originprice != a.price"><s><span>{{a.originprice}}</span>巢币</s></p>
        </div>
        <div class="courseInfo">
          <img v-if="a.mode_name == '更新中'" src="../../../assets/image/icon/update.png" alt="" class="courseType">
          <img v-else src="../../../assets/image/icon/theEnd.png" alt="" class="courseType">
          <p class="courseNum">{{a.hitnum}}人已参加</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {pagebase} from '@/utils/http'

  export default {
    props: ['userId'],

    data() {
      return {
        teachingList: [],
        pagebase: pagebase,
      }
    },

    mounted() {
      this.init();
    },

    methods: {
      init() {
        this.getTeachingList();
      },

      getTeachingList() {
        this.$http({
          url: '/edu/listTeaching',
          method: 'get',
          params: {
            start: 0,
            limit: 10,
            uid: this.userId,
          }
        }).then(res => {
          if (res.code >= 0) {
            this.teachingList = res.data;
            this.getListLength(res.code)
          }else{
            this.getListLength(res.code)
          }
        })
      },
      
      goCourse(id){
        sessionStorage.setItem('cur', 2);
        this.$router.push({
          path: '/elaborateCourseShare',
          query: {
            courseid: id,
          }
        })
      },
      
      getListLength(code){
        this.$emit('length', code)
      },
    },
  }
</script>

<style lang="css" scoped>
  .content {
    box-sizing: border-box;
    padding: 1.5rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  
  .teachingList {
    width: 48%;
    position: relative;
    margin-bottom: 1.65rem;
  }

  .courseBanner {
    width: 100%;
    height: 10.3rem;
    border-radius: .6rem;
    background-size: cover;
    overflow: hidden;
    position: relative;
  }
  
  .discountIcon {
    width: 5rem;
  }
  
  .discountNum{
    position: absolute;
    font-size: 1rem;
    color: #FFFFFF;
    left: .2rem;
    top: .7rem;
    transform: rotate(-42deg);
  }
  
  .courseTitle{
    font-size: 1.4rme;
    color: #1D2023;
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
    margin-top: .6rem;
  }
  
  .coursePrice{
    display: flex;
    align-items: flex-end;
  }
  
  .currentPrice{
    margin-top: .5rem;
    font-size: 1rem;
    color: #FF0225;
    margin-right: .5rem;
  }
  
  .currentPrice span{
    font-size: 1.4rem;
  }
  
  .originalCost {
    font-size: 1rem;
    color: #9CA3A9;
  }
  
  .courseInfo{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: .6rem;
  }
  
  .update {
    display: flex;
    align-items: center;
    font-size: 1rem;
  }
  
  .courseType{
    width: 5rem;
    height: 1.7rem;
  }
  
  .courseNum{
    font-size: 1rem;
    color: #9CA3A9;
  }
</style>
